export const APPROVE_CUSTOMER_MODAL_ID = "APPROVE_CUSTOMER_MODAL";

export enum DefaultSupplyLimitEnum {
    Default = "DEFAULT",
    Unlimited = "UNLIMITED",
}

export enum StartPointEnum {
    List = "LIST",
    Detail = "DETAIL",
}
